// src/components/templates/PageTemplate/index.tsx
import React from 'react';
import { Box } from '@mui/material';
import styles from '@/components/templates/RawTemplate/rawtemplate.module.css';

interface RawTemplateProps {
  children: React.ReactNode;
}

const RawTemplate: React.FC<RawTemplateProps> = ({ children }) => {
  return (
    <Box className={styles.root}>
      <Box className={styles.container}>{children}</Box>
    </Box>
  );
};

export default RawTemplate;
